import { render, staticRenderFns } from "./FirstChildAction.vue?vue&type=template&id=23f482d1&scoped=true&"
import script from "./FirstChildAction.vue?vue&type=script&lang=js&"
export * from "./FirstChildAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f482d1",
  null
  
)

export default component.exports